module.exports = __webpack_public_path__ + "img/operate_icon_2.efa2ceba.png";